<template>
  <div class="container">
    <!-- navbar -->
    <van-nav-bar title="我的优鲜团点">
			<van-icon name="arrow-left" @click="goBack" color="#fff" size="20" data-stat="返回" slot="left" />
      <template #right>
        <div v-if="qrCodeData" @click="qrCodeshow = true;" class="right">邀请团长</div>
      </template>
		</van-nav-bar>
    <!-- tabs -->
    <div class="tabs flex-m-space">
      <div @click="cycleShow = !cycleShow" :class="['tab active cycle', cycleShow ? 'up' : '']">{{ actCycles[actCycle] }}</div>
      <div @click="checkDx = true; dx = !dx; getData();" :class="['tab flex-c-m sort', checkDx ? 'active' : '', dx ? 'check' : '']">是否动销</div>
      <div @click="checkSalesNum = true; checkGMV = false; salesNum = !salesNum; getData();" :class="['tab flex-c-m sort', checkSalesNum ? 'active' : '', checkSalesNum && salesNum ? 'check' : '']">销售件数</div>
      <div @click="checkGMV = true; checkSalesNum = false; gmv = !gmv; getData();" :class="['tab flex-c-m sort', checkGMV ? 'active' : '', checkGMV && gmv ? 'check' : '']">GMV</div>
      <div @click="helpShow = true; getRules()" class="tab hp">帮助</div>
    </div>
    <!-- options -->
    <div @click="cycleShow = false" v-if="cycleShow" class="options-mask fadeIn"></div>
    <div :class="['options', cycleShow ? 'show' : '']">
      <div @click="actCycle = item.value; cycleShow = false" v-for="(item, index) in option" :key="index" :class="['item', 'flex-m', actCycle == item.value ? 'select' : '']">{{ item.text }}</div>
    </div>
    <!-- helps -->
    <van-popup v-model="helpShow" round>
      <div class="title">帮助说明<p @click="close">关闭</p></div>
      <div v-html="helpContent" class="content"></div>
    </van-popup>
    <!-- qrCode -->
    <van-popup v-model="qrCodeshow" round>
      <div class="title">邀请团长二维码<p @click="close">关闭</p></div>
      <div style="display: flex;justify-content: center;" class="content">
        <img :src="qrCodeData" alt="QR Code">
      </div>
      <div style="text-align: center;">提供团长进行扫码</div>
    </van-popup>
    <!-- lists -->
    <van-pull-refresh v-if="dataList && dataList.length > 0" v-model="refeshLoding" @refresh="onRefresh">
      <ul>
        <li v-for="(data, index) in dataList" :key="index">
          <div class="groupName flex-m">{{ data.siteName || ''}}</div>
          <div class="greyText flex-m j-sb">
            <span>团长姓名:{{data.userName || ''}}</span>
            <!-- <span>距离:768.4km</span> -->
          </div>
          <div class="greyText">详细地址:{{data.address || ''}}</div>
          <div class="statistics flex-c-m">
            <div v-for="item in statistics" :key="item.key" class="item">
              <div>{{ item.key == 'dx' ? data[item.key] ? '是' : '否' : data[item.key] }}</div>
              <div>{{ item.label }}</div>
            </div>
          </div>
        </li>
        <div class="finishText"> {{ finishText }}</div>
      </ul>
    </van-pull-refresh>
    <van-empty
      v-else
      class="custom-image"
      :image="require('./i/none.png')"
      description="当前地址暂无优鲜团点"
    />
  </div>
</template>
<script>
import { ylyxGetGroupIdListByBdId, rulesinfo, getYzsInfoNew } from "@/libs/api";
import { uleUrl, getCookie, browser } from "@/libs/common";
import QRCode from 'qrcode'
import axios from "axios";
import md5 from 'md5';
export default {
  name:'',
  data() {
    return {
      helpShow: false,
      qrCodeshow: false,
      qrCodeData: '',
      cycleShow: false,
      actCycle: '1',
      dx: false,
      gmv: false,
      salesNum: false,
      checkDx: false,
      checkGMV: false,
      checkSalesNum: false,
      helpContent: '',
      refeshLoding: false,
      option: [
        { text: '今日下单', value: '1' },
        { text: '2天内下单', value: '2' },
        { text: '3天内下单', value: '3' },
        { text: '7天内下单', value: '7' },
      ],
      statistics: [
        {key: 'dx', label: '是否动销'},
        {key: 'salesNum', label: '销售件数'},
        {key: 'gmv', label: 'GMV'},
      ],
      actCycles: {
        1: '今日下单',
        2: '2天内下单',
        3: '3天内下单',
        7: '7天内下单'
      },
      dataList: [],
      totalPage: 1,
      currentPage: 1,
      pageSize: 20,
      finishText: '加载中...',
      location: null,
      yzsSignData: {
        beta: {
          appId: 10045,
          secret: "e2bdf83b4d468ba9",
        },
        testing: {
          appId: 10040,
          secret: "56f23bf3b0c6b1b3",
        },
        prod: {
          appId: 10053,
          secret: "c6eeb7907c161d4c",
        }
      }
    }
  },
  watch: {
    actCycle() {
      this.getData()
    }
  },
  mounted() {
    // 获取经纬度
    this.location = getCookie("location") && JSON.parse(getCookie("location")).location
    // 获取数据
    this.getData()
    let that = this
    window.onscroll = () => {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight) {
        console.log("到底咯");
        that.nextPage()
      }
    };
    this.generateQRCode();
  },
  methods:{
    goBack() {
      if (browser().yzs) {
        window.location.href = 'ulemobile://ulePopView';
      } else {
        this.$router.go(-1);
      }
    },
    close() {
      this.helpShow = false
      this.qrCodeshow = false
    },
    onRefresh() {
      this.getData();
    },
    getRules() {
      if (this.helpContent) return 
      this.$toast.loading({
        duration: 0,
        overlay: true,
        message: "请稍等...",
      });
      let id = /beta|testing/.test(uleUrl()) ? '733' : '6615'
      rulesinfo(id).then(res=>{
        this.$toast.clear()
        if(res.code == '0000' && res.data && res.data.content){
          this.helpContent = JSON.parse(res.data.content).modules.headpic.data.ruleText
        }
      })
    },
    generateQRCode() {
      let timestamp = new Date().getTime();
      let key = /beta/.test(uleUrl()) ? 'beta' : /testing/.test(uleUrl()) ? 'testing' : 'prod'
      let signText = this.yzsSignData[key].appId + this.yzsSignData[key].secret + timestamp;
      console.log('secret+timestamp:', signText)
      let sign = md5(signText);
      console.log('sign:', sign)
      axios.post(`//wholesale-api.${uleUrl()}/yzsmgr/businessBind/getYzsInfoNew?timestamp=${timestamp}&sign=${sign}&appId=${this.yzsSignData[key].appId}`, {}, {
        withCredentials: true, 
        headers: {
          'Content-Type': 'application/json',
        }
      }).then((response) => {
        console.log('res>>', response.data)
        let result = response.data;
        if (result && result.returnCode == '0000' && result.data) {
          if (result.data.businessBind && result.data.businessBind.length > 0) {
            result.data.businessBind.filter(e=> {
              if (e.bindType == '0') {
                let text = `https://h5.ule.com/hd/2022/tzreg/index.html?orgId=${result.data.orgCity}&recommendUserId=${result.data.usrOnlyid}`
                console.log('qrCode:', text)
                QRCode.toDataURL(text, (err, url) => {
                  if (err) {
                    console.error(err);
                  } else {
                    this.qrCodeData = url;
                  }
                });
              } 
            })
          }
        }
      });
    },
    getData(isNext) {
      this.$toast.loading({
        duration: 0,
        overlay: true,
        message: "加载中...",
      });
      if (!isNext) {
        this.currentPage = 1
      } 
      let p = {
        actCycle: this.actCycle,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      if (this.checkDx) p.dx = this.dx ? '1' : '0'; 
      if (this.checkSalesNum) p.salesNum = this.salesNum ? '1' : '0'; 
      if (this.checkGMV) p.gmv = this.gmv ? '1' : '0'; 
      
      if (this.location) {
        p.lat = this.location.split(',')[0]
        p.lon = this.location.split(',')[1]
      }

      console.log('P>>>:', p)
      ylyxGetGroupIdListByBdId(p, `jsoncallback${this.currentPage}`).then((res) => {
        this.refeshLoding = false
        this.$toast.clear()
        if (res && res.returnCode == '0000' && res.data && res.data.dataList) {
          if (isNext) {
            this.dataList = this.dataList.concat(res.data.dataList)
          } else {
            this.dataList = res.data.dataList
          }
          this.totalPage = Math.ceil(res.data.total / this.pageSize)
        } else {
          if (res.returnMessage) this.$toast(res.returnMessage)
        }
      })
    },
    nextPage() {
      this.currentPage ++
      if (this.currentPage > this.totalPage) {
        this.finishText = '- 到底咯 -'
        return
      }
      this.getData(true)
    }
  },
};
</script>
<style lang="scss" scoped>
@import "./css/index.scss";
</style>
